<template>
  <v-card v-if="accountData != null" flat class="pa-3 mt-2">
    <v-card-text class="d-flex">
      <!-- upload photo -->
      <div>
        <avatar-image-component :edit="adminProfileStore.id == accountData.id" :avatarUrl="accountData.avatar" :user="accountData"></avatar-image-component>
      </div>
    </v-card-text>

    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        class="multi-col-validation mt-6"
        lazy-validation
      >
        <v-row>
          <v-col md="6" cols="12">
            <v-text-field
              v-model="accountData.name"
              :label="$t('common.name')"
              dense
              outlined
              required
              :rules="nameRules"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="accountData.email"
              :label="$t('users.accountSettings.emailLabel')"
              :disabled="accountData.id != 1 && userType !== 'student'"
              dense
              outlined
              required
              :rules="emailRules"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-select
            disabled
              v-model="accountData.role_id"
              dense
              outlined
              :label="$t('users.accountSettings.roleLabel')"
              :items="roles"
              item-text="role"
              item-value="value"
            ></v-select>
          </v-col>

          <v-col cols="12" md="6">
            <v-select
              v-model="accountData.status_id"
              :disabled="accountData.id == 1"
              dense
              outlined
              :label="$t('common.status')"
              :items="statuses"
              item-text="status"
              item-value="value"
            ></v-select>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="accountData.tel_number"
              outlined
              dense
              :label="$t('common.phone')"
              :rules="phoneRules"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6" v-if="userType == 'student'">
            <v-text-field
              v-model="accountData.student_identification"
              outlined
              dense
              :label="$t('users.accountSettings.studentIdLabel')"
            ></v-text-field>
          </v-col>
          <v-col v-else-if="userType == 'school' || (userType == 'guardian' && accountData.role_id==4)">
            <v-text-field
              v-model="accountData.balance"
              :disabled="userType == 'guardian' && accountData.role_id==4"
              outlined
              dense
              :label="$t('users.accountSettings.balanceLabel')"
            ></v-text-field>
          </v-col>

            <v-col cols="12" md="6" v-if="userType == 'school'">
                <v-text-field
                v-model="accountData.invoice_data_title"
                outlined
                dense
                :label="$t('users.fields.invoiceDataTitle')"
                :rules="nameRules"
                ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="userType == 'school'">
                <v-text-field
                v-model="accountData.company_name"
                outlined
                dense
                :label="$t('users.fields.companyName')"
                :rules="nameRules"
                ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="userType == 'school'">
                <v-text-field
                v-model="accountData.company_job"
                outlined
                dense
                :label="$t('users.fields.companyJob')"
                :rules="nameRules"
                ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="userType == 'school'">
                <v-text-field
                v-model="accountData.company_address"
                outlined
                dense
                :label="$t('users.fields.companyAddress')"
                :rules="nameRules"
                ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="userType == 'school'">
                <v-text-field
                v-model="accountData.company_address_po_box"
                outlined
                dense
                :label="$t('users.fields.companyAddressPoBox')"
                :rules="nameRules"
                ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="userType == 'school'">
                <v-text-field
                v-model="accountData.company_city"
                outlined
                dense
                :label="$t('users.fields.companyCity')"
                :rules="nameRules"
                ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="userType == 'school'">
                <v-text-field
                v-model="accountData.company_country"
                outlined
                dense
                :label="$t('users.fields.companyCountry')"
                :rules="nameRules"
                ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="userType == 'school'">
                <v-text-field
                v-model="accountData.company_vat"
                outlined
                dense
                :label="$t('users.fields.companyVat')"
                :rules="nameRules"
                ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="userType == 'school'">
                <v-text-field
                v-model="accountData.company_gemi_number"
                outlined
                dense
                :label="$t('users.fields.companyGemiNumber')"
                :rules="nameRules"
                ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="userType == 'school'">
                <v-text-field
                v-model="accountData.tax_office"
                outlined
                dense
                :label="$t('users.accountSettings.companyTaxOfficeLabel')"
                :rules="nameRules"
                ></v-text-field>
            </v-col>

          <v-col cols="12">
            <v-btn color="primary" class="me-3 mt-4" @click="saveUser">
              {{ $t('users.accountSettings.saveChanges') }}
            </v-btn>
            <v-btn
              color="secondary"
              outlined
              class="mt-4"
              @click="ΠΙΣΩ"
            >
              {{ $t('common.cancel') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>

import AvatarImageComponent from '../../../components/AvatarImageComponent.vue'
import { mdiAlertOutline, mdiCloudUploadOutline } from "@mdi/js";
import { adminProfileStore } from "@/utils/helpers";

export default {
  components: {
    AvatarImageComponent
  },
  setup() {
    return { adminProfileStore }
  },
  props: {
    accountData: {
      type: Object,
      default: () => {},
    },
    userType: {
      type: String,
      default: () => {},
    },
  },
  data() {
    return {
      valid: true,
      nameRules: [(v) => !!v || this.$t("users.accountSettings.nameRequired")],
      emailRules: [
        v => !!v || this.$t("users.accountSettings.emailRequired"),
        v => /.+@.+\..+/.test(v) || this.$t("users.accountSettings.emailInvalid"),
      ],
      phoneRules: [
        v => /^(|\d)+$/.test(v) || this.$t("users.accountSettings.phoneInvalid"),
      ],
      icons: {
        mdiAlertOutline,
        mdiCloudUploadOutline,
      },
    };
  },
  computed: {
    statuses() {
      return [
        { status: this.$t("common.active"), value: 1 },
        { status: this.$t("users.accountSettings.statusSuspended"), value: 3 },
      ];
    },
    roles() {
      return [
        { role: this.$t("users.roles.admin"), value: 1 },
        { role: this.$t("users.roles.school"), value: 2 },
        { role: this.$t("users.roles.driver"), value: 3 },
        { role: this.$t("users.roles.parent"), value: 4 },
        { role: this.$t("users.roles.guardian"), value: 5 },
        { role: this.$t("users.roles.student"), value: 6 },
      ];
    },
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    saveUser() {
      if (!this.validate()) return;
      this.$emit("save-user-info");
    },
    cancel()
    {
      this.$router.go(-1);
    }
  },
};
</script>
